import produce from 'immer';
import margeById from '../../helpers/margeById';
export const actions = {
  /**
   * Action that fire/trigger redux-saga watchers
   */
  CREATE_JARTISAN: 'CREATE_JARTISAN',
  DELETE_JARTISAN: 'DELETE_JARTISAN',
  GET_JARTISAN: 'GET_JARTISAN',
  GET_SINGLE_JARTISAN: 'GET_SINGLE_JARTISAN',
  GET_JARTISAN_PENDING: 'GET_JARTISAN_PENDING',
  UPDATE_JARTISAN: 'UPDATE_JARTISAN',
  UPDATE_JARTISAN_APPLICANT_STATUS: 'UPDATE_JARTISAN_APPLICANT_STATUS',
  /**
   * Actions that are fired BY redux-saga watchers after a response
   */

  GET_JARTISAN_SUCCESS: 'GET_JARTISAN_SUCCESS',
  GET_SINGLE_JARTISAN_SUCCESS: 'GET_SINGLE_JARTISAN_SUCCESS',
  UPDATE_JARTISAN_APPLICANT_STATUS_SUCCESS:
    'UPDATE_JARTISAN_APPLICANT_STATUS_SUCCESS',
  GET_JARTISAN_PENDING_SUCCESS: 'GET_JARTISAN_PENDING_SUCCESS',
  CREATE_JARTISAN_SUCCESS: 'CREATE_JARTISAN_SUCCESS',
  UPDATE_JARTISAN_SUCCESS: 'UPDATE_JARTISAN_SUCCESS',
  DELETE_JARTISAN_SUCCESS: 'DELETE_JARTISAN_SUCCESS',
  /**
   * Misc
   */
  SET_JARTISAN_IS_LOADING: 'SET_JARTISAN_IS_LOADING',
  SET_JARTISAN_COUNT: 'SET_JARTISAN_COUNT',
  SET_AT_SEARCH_VALUE: 'SET_AT_SEARCH_VALUE'
};

const initialState = {
  items: [],
  pennding: [],
  singleJob: [],
  isLoading: false,
  count: 0,
  searchValue: ''
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.CREATE_JARTISAN_SUCCESS: {
      const currentJobs = draft.pennding;
      const job = payload;
      draft.pennding = margeById(currentJobs, [job]);
      break;
    }

    case actions.UPDATE_JARTISAN_SUCCESS: {
      const updatedCategory = payload;
      const targetIndex = draft.items.findIndex(
        job => job._id === updatedCategory._id
      );
      draft.items[targetIndex] = updatedCategory;
      break;
    }

    case actions.GET_JARTISAN_SUCCESS: {
      const currentJobs = draft.items;
      draft.items = margeById(currentJobs, payload);
      break;
    }

    case actions.GET_JARTISAN_PENDING_SUCCESS: {
      const currentJobs = draft.pennding;
      draft.pennding = margeById(currentJobs, payload);
      break;
    }

    case actions.DELETE_JARTISAN_SUCCESS: {
      draft.pennding = draft.pennding.filter(item => item._id !== payload);
      break;
    }

    case actions.GET_SINGLE_JARTISAN_SUCCESS: {
      draft.singleJob = payload;
      break;
    }

    case actions.UPDATE_JARTISAN_APPLICANT_STATUS_SUCCESS: {
      // draft.singleJob.applicants = payload.applicants;
      // console.log(draft, payload, 'draft.singleJob');
      // draft?.singleJob?.map(item =>{
      //   console.log(item, 'draft.singleJob')
      // })
      // console.log()
      break;
    }
    /**
     * Misc
     */

    case actions.SET_JARTISAN_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }

    case actions.SET_JARTISAN_COUNT: {
      draft.count = payload;
      break;
    }

    case actions.SET_AT_SEARCH_VALUE: {
      draft.items = [];
      draft.searchValue = payload;
      break;
    }

    default:
      break;
  }
});
